// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"625":"cf98dbe1","866":"094e8800","988":"795dd79f"}[chunkId] + ".js";
};